import React from 'react'
// import TextField from '@mui/material/TextField';
// import signupimg from '../../../../assets/images/signup-img.jpeg';
export default function BookNow() {
    return (
        <div>
            <div>
                <div className=" h-[50vh] content-center "  >
                    <div className="w-full lg:w-6/12 md:w-6/12 p-0 mx-auto">
                        <div className="bg-white lg:shadow-md lg:border md:border md:shadow-md flex rounded-2xl sm:w-full ">
                            {/* Form Section */}
                            <div className=" flex items-center justify-center w-full sm:my-2 "  >
                                <form className="space-y-4 lg:w-72 md:w-60" >
                                    <h5 className='mt-3 text-center font-bold'>Book Your Drone Service </h5>

                                    {/* Full Name */}
                                    <div className="mb-3">
                                        <label htmlFor="formGroupEmail" className="block font-medium text-gray-700">
                                            Name
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter name"
                                            className="w-full lg:px-3 lg:py-2 border rounded-md focus:outline-none md:px-2 md:py-1 sm:px-2 py-1"
                                        />
                                    </div>
                                    {/* Email number*/}
                                    <div className="mb-3">
                                        <label htmlFor="formGroupEmail" className="block font-medium text-gray-700">
                                            Email address
                                        </label>
                                        <input
                                            type="email"
                                            placeholder="Enter email"
                                            className="w-full lg:px-3 lg:py-2 border rounded-md focus:outline-none md:px-2 md:py-1 sm:px-2 py-1"
                                        />
                                    </div>
                                    {/* Select service */}
                                    <div className="mb-3">
                                        <label htmlFor="formGroupEmail" className="block font-medium text-gray-700">
                                            Select service
                                        </label>
                                        <select
                                            className="w-full lg:px-3 lg:py-2 border rounded-md focus:outline-none md:px-2 md:py-1 sm:px-2 py-1"

                                        >
                                            <option>None</option>
                                            <option>Mapping</option>
                                            <option>agriculture</option>
                                            <option>agricul</option>
                                        </select>

                                    </div>

                                    {/* Date Input */}
                                    <div className="mb-3">
                                        <label htmlFor="formGroupEmail" className="block font-medium text-gray-700">
                                            Description
                                        </label>
                                        <textarea

                                            className="w-full lg:px-3 lg:py-2 border rounded-md focus:outline-none md:px-2 md:py-1 sm:px-2 py-1"
                                        />
                                    </div>



                                    {/* Signup Button */}
                                    <div className="flex justify-center mt-2  p-2">
                                        <button className="w-full bg-[#f97316] text-white lg:py-2 rounded-lg font-medium text-base md:py-1 ">
                                            Book Now
                                        </button>
                                    </div>



                                </form>
                            </div>

                            {/* Image Section */}
                            <div className=" justify-end items-center sm:w-0 lg:w-11/12 md:w-11/12 hidden sm:flex">
                                <img src={''} alt="signup" className="rounded-r-2xl h-100" />
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}
